<template>
    <section class="home-container">
        <MasterPage title="食谱模板">
            <div slot="title-icon">
                <Icon type="md-analytics" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="模板名称：">
                            <Input v-model="select.name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="模板状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" clearable placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="12">
                        <FormItem label="年龄：">
                            <InputNumber v-model="select.age" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="性别：">
                            <Select v-model="select.sex" @on-change="pageNum = 1" clearable placeholder="请选择">
                                <Option value="男">男</Option>
                                <Option value="女" >女</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addItem_modal">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" :styles="{top: '20px'}" width="85%" title="新增食谱模板" @on-cancel="cancelItem">
            <Form :label-width="80">
                <FormItem label="模板名称：">
                    <Input v-model="addItem.name" placeholder="请输入" />
                </FormItem>
            </Form>
            <Form :label-width="80">
                <Row>
                    <Col span="8">
                        <FormItem label="饮食原则：">
                            <Select transfer multiple v-model.sync="addItem.dietGuidelines" placeholder="请选择">
                                <Option v-for="item in dietGuidelinesAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="年龄：">
                        <InputNumber v-model="addItem.ageMin" placeholder="请输入" />
                        -
                        <InputNumber v-model="addItem.ageMax" placeholder="请输入" />
                        岁
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="性别：">
                        <Select v-model="addItem.sex" placeholder="请选择">
                            <Option value="男">男</Option>
                            <Option value="女" >女</Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <Table border max-height="670" stripe :columns="columnsAdd" :data="itemAdd">
                <template v-for="week in weekList" slot-scope="{ row, index }" :slot="week">
                    <Form style="margin: 10px 0" v-if="index < 4">
                        <Row v-for="(templateInfo,indes) in addItem.infoList[row[week]]" :key="templateInfo.key">
                            <Col span="12">
                              <FormItem style="margin: 10px 5px">
                                <Select v-if="templateInfo.select.edit"
                                        @mouseout.native="!templateInfo.select.click ? templateInfo.select.edit = false : null"
                                        @click.native="templateInfo.select.click = true"
                                        @on-change="changeSelect($event, templateInfo)" label-in-value
                                        transfer filterable  v-model="templateInfo.foodMaterialId" placeholder="请选择食材">
                                  <Option v-for="item in foodMaterialAllList" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</Option>
                                </Select>
                                <div v-else @mouseover="templateInfo.select.edit = true"
                                     style="line-height: 30px;border: 1px solid rgb(220, 222, 226);border-radius: 4px;background-color: white"
                                >
                                  {{templateInfo.foodMaterial != null ? templateInfo.foodMaterial.name : templateInfo.foodMaterialName}}
                                </div>
                              </FormItem>
                            </Col>
                            <Col span="6">
                            <FormItem style="margin: 10px 5px">
                              <InputNumber style="width: 75px" :min="0" v-model="templateInfo.value"placeholder="请输入食材数量"></InputNumber>
                              <span style="padding-left: 5px">克</span>
                            </FormItem>
                            </Col>
                            <!--<Col span="2">-->
                                <!--<Poptip :transfer="true" placement="right">-->
                                    <!--<Button title="备注" class="my_Button" style="border: 0px;padding: 0px;background-color: inherit;line-height: 4;">-->
                                        <!--<Icon type="md-git-network" size="20" />-->
                                    <!--</Button>-->
                                    <!--<div class="api" slot="content">-->
                                        <!--<Input type="text" v-model="templateInfo.remark" placeholder="请输入备注" />-->
                                    <!--</div>-->
                                <!--</Poptip>-->
                            <!--</Col>-->
                            <Col span="4">
                            <FormItem style="margin: 10px 5px">
                                <Button @click="removeTemplateInfo(indes,row[week])">删除</Button>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <FormItem style="margin: 10px 5px">
                                <Button type="dashed" long @click="addTemplateInfo(row[week])" icon="md-add">添加新的食物</Button>
                            </FormItem>
                        </Row>
                    </Form>
                    <div v-else>
                        <Button type="primary" @click="editGetNutritions(addItem.infoList, row[week][0], 'basic')">基础物质</Button>
                        <Button type="primary" @click="editGetNutritions(addItem.infoList, row[week][0])" style="margin-left: 5px">其它物质</Button>
                    </div>
                </template>
            </Table>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItemClick()">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" :styles="{top: '20px'}" title="修改食谱模板" width="85%" @on-cancel="cancelItem">
            <Form :label-width="80">
                <FormItem label="模板名称：">
                    <Input v-model="updateInfoItem.name" placeholder="请输入" />
                </FormItem>
            </Form>
            <Form :label-width="80">
                <Row>
                    <Col span="8">
                    <FormItem label="饮食原则：">
                        <Select transfer multiple v-model.sync="updateInfoItem.dietGuidelines" placeholder="请选择">
                            <Option v-for="item in dietGuidelinesAllList" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="年龄：">
                        <InputNumber v-model="updateInfoItem.ageMin" placeholder="请输入" />
                        -
                        <InputNumber v-model="updateInfoItem.ageMax" placeholder="请输入" />
                        岁
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="性别：">
                        <Select v-model="updateInfoItem.sex" placeholder="请选择">
                            <Option value="男">男</Option>
                            <Option value="女" >女</Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
            </Form>

            <Table border max-height="670" stripe :columns="columnsAdd" :data="itemAdd">
                <template v-for="week in weekList" slot-scope="{ row, index }" :slot="week" >
                    <Form style="margin: 10px 0" v-if="index < 4">
                        <Row v-for="(templateInfo,indes) in updateInfoItem.infoList[row[week]]" :key="templateInfo.key">
                            <Col span="12">
                            <FormItem style="margin: 10px 5px">
                                <Select v-if="templateInfo.select.edit"
                                        @mouseout.native="!templateInfo.select.click ? templateInfo.select.edit = false : null"
                                        @click.native="templateInfo.select.click = true"
                                        @on-change="changeSelect($event, templateInfo)" label-in-value
                                        transfer filterable  v-model="templateInfo.foodMaterialId" placeholder="请选择食材">
                                      <Option v-for="item in foodMaterialAllList" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</Option>
                                </Select>

                                <!--<Select v-if="templateInfo.select.edit"-->
                                        <!--@mouseout.native="templateInfo.select.edit = false"-->
                                        <!--@click.native="templateInfo.select.click = true"-->
                                        <!--@on-change="changeSelect($event, templateInfo)" label-in-value-->
                                        <!--transfer filterable  v-model="templateInfo.foodMaterialId" placeholder="请选择食材">-->
                                    <!--<Option v-for="item in foodMaterialAllList" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</Option>-->
                                <!--</Select>-->
                                <!--<Select v-if="templateInfo.key == clickItemKey"-->
                                        <!--@mouseout.native="!templateInfo.select.click ? templateInfo.select.edit = false : null"-->
                                        <!--@click.native="clickItemKey = templateInfo.key"-->
                                        <!--@on-change="changeSelect($event, templateInfo)" label-in-value-->
                                        <!--transfer filterable  v-model="templateInfo.foodMaterialId" placeholder="请选择食材">-->
                                    <!--<Option v-for="item in foodMaterialAllList" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</Option>-->
                                <!--</Select>-->
                                <!--clickItemKey-->
                              <div v-else @mouseover="templateInfo.select.edit = true"
                                   style="line-height: 30px;border: 1px solid rgb(220, 222, 226);border-radius: 4px;background-color: white"
                              >
                                {{templateInfo.foodMaterial != null ? templateInfo.foodMaterial.name : templateInfo.foodMaterialName}}
                              </div>
                            </FormItem>
                            </Col>
                            <Col span="6">
                            <FormItem style="margin: 10px 5px">
                                <InputNumber style="width: 75px" :min="0" v-model="templateInfo.value"placeholder="请输入食材数量"></InputNumber>
                                <span style="padding-left: 5px">克</span>
                            </FormItem>
                            </Col>
                            <!--<Col span="2">-->
                            <!--<Poptip :transfer="true" placement="right">-->
                                <!--<Button class="my_Button" title="备注" style="border: 0px;padding: 0px;background-color: inherit;line-height: 4;">-->
                                    <!--<Icon type="md-git-network" size="20" />-->
                                <!--</Button>-->
                                <!--<div class="api" slot="content">-->
                                    <!--<Input type="text" v-model="templateInfo.remark" placeholder="请输入备注" />-->
                                <!--</div>-->
                            <!--</Poptip>-->
                            <!--</Col>-->
                            <Col span="4">
                            <FormItem style="margin: 10px 5px">
                                <Button @click="removeInfoList(indes, row[week])">删除</Button>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <FormItem style="margin: 10px 5px">
                                <Button type="dashed" long @click="addInfoList(row[week])" icon="md-add">添加新的食物</Button>
                            </FormItem>
                        </Row>
                    </Form>
                    <div v-else>
                        <Button type="primary" @click="editGetNutritions(updateInfoItem.infoList, row[week][0], 'basic')">基础物质</Button>
                        <Button type="primary" @click="editGetNutritions(updateInfoItem.infoList, row[week][0])" style="margin-left: 5px">其它物质</Button>
                    </div>
                </template>
            </Table>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="食谱模板详情" width="85%">
            <Form :label-width="80">
                <FormItem label="模板名称：">
                    {{infoItem.name}}
                </FormItem>
            </Form>
            <Form :label-width="80">

                <Row>
                    <Col span="8">
                        <FormItem label="饮食原则：">
                            <span v-for="item in dietGuidelinesAllList" v-if="infoItem.dietGuidelines != null && infoItem.dietGuidelines.indexOf(item.id) > -1" style="margin-right: 20px">{{item.name}}</span>
                        </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="年龄：">
                        <InputNumber v-model="infoItem.ageMin" placeholder="请输入" />
                        -
                        <InputNumber v-model="infoItem.ageMax" placeholder="请输入" />
                        岁
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="性别：">
                        <Select v-model="infoItem.sex" placeholder="请选择">
                            <Option value="男">男</Option>
                            <Option value="女" >女</Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <Table border stripe :columns="columnsIndo" :data="itemAdd"></Table>
        </Modal>
        <Modal v-model="nutritionModal" title="营养物质含量">
            <Table border stripe :loading="tableLoading" :columns="nutritionColumn" :data="nutritionItems"></Table>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                nutritionModal: false, // 营养物质弹窗
                nutritionColumn:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.foodNutritionId != null) {
                                return h('span',params.row.name+"("
                                    + params.row.forShort+")")
                            }
                        }
                    },
                    {
                        title: '含量',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.foodNutritionId != null) {
                                return h('span', params.row.value + " " + params.row.unit)
                            }
                        }
                    },
                ], // 营养物质列
                nutritionItems:[], // 营养物质的数据
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '模板名称',
                        key: 'name',
                        align: 'center',
                    },
                    {
                        title: '年龄',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].ageMin || this.dataList[params.index].ageMax) {
                                return h('span', (this.dataList[params.index].ageMin ? this.dataList[params.index].ageMin : 0)
                                + '-' + (this.dataList[params.index].ageMax ? this.dataList[params.index].ageMax + '岁' : '以上'))
                            }
                        }
                    },
                    {
                        title: '性别',
                        key: 'sex',
                        align: 'center',
                    },
                    {
                        title: '状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.CopyItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '复制')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                foodMaterialAllList:[],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                select:{
                    name:'',
                    isDeleted:'false',
                    age: null,
                    sex: ''
                },
                columnsAdd:[
                    {
                        title: '时间',
                        width: 100,
                        key:'dataTime',
                        align: 'center',
                        fixed: 'left'
                    },
                    {
                        title: '周天',
                        key: 'age',
                        align: 'center',
                        slot:'sev',
                        width: 450,
                    },
                    {
                        title: '周一',
                        align: 'center',
                        slot:'one',
                        width: 450,
                    },
                    {
                        title: '周二',
                        align: 'center',
                        slot:'tow',
                        width: 450,
                    },
                    {
                        title: '周三',
                        key: 'age',
                        align: 'center',
                        slot:'thr',
                        width: 450,
                    },
                    {
                        title: '周四',
                        key: 'age',
                        align: 'center',
                        slot:'fou',
                        width: 450,
                    },
                    {
                        title: '周五',
                        key: 'age',
                        align: 'center',
                        slot:'fiv',
                        width: 450,
                    },
                    {
                        title: '周六',
                        key: 'age',
                        align: 'center',
                        slot:'six',
                        width: 450,
                    },
                ],
                itemAdd:[{dataTime:'早餐',one:'01',tow:'11',thr:'21',fou:'31',fiv:'41',six:'51',sev:'61'},
                    {dataTime:'午餐',one:'02',tow:'12',thr:'22',fou:'32',fiv:'42',six:'52',sev:'62'},
                    {dataTime:'晚餐',one:'03',tow:'13',thr:'23',fou:'33',fiv:'43',six:'53',sev:'63'},
                    {dataTime:'加餐',one:'04',tow:'14',thr:'24',fou:'34',fiv:'44',six:'54',sev:'64'},
                    {dataTime:'营养物质',one:'04',tow:'14',thr:'24',fou:'34',fiv:'44',six:'54',sev:'64'}],
                addItem: {
                    name:'',
                    sex: null,
                    ageMin: null,
                    ageMax: null,
                    infoList: []
                },
                dietGuideLine: null,
                TemplateInfoList:{},
                weekList:['sev','one','tow','thr','fou','fiv','six'],
                infoItem:{infoVOList:[]},
                columnsIndo:[
                    {
                        title: '时间',
                        width: 60,
                        align: 'center',
                        render:(h,params)=>{
                            if (params.index < 4) {
                                let week=['早','午','晚','加']
                                return h("span",week[params.index] + "餐")
                            } else {
                                return h("span", "营养分析")
                            }
                        }
                    },
                    {
                        title: '周天',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            if (params.index < 4) {
                                let code = 6 + "" + (params.index+1)
                                let hList = []
                                this.infoItem.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark == null || info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                                return h("div",hList)
                            } else {
                                let Buttons = [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 6, 'basic')
                                            }
                                        }
                                    }, '基础物质'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 6)
                                            }
                                        }
                                    }, '其它物质')
                                ]
                                return h("div",Buttons)
                            }
                        }
                    },
                    {
                        title: '周一',
                        align: 'center',
                        render:(h,params)=>{
                            if (params.index < 4) {
                                let code = 0 + "" + (params.index+1)
                                let hList = []
                                this.infoItem.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark == null || info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                                return h("div",hList)
                            } else {
                                let Buttons = [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 0, 'basic')
                                            }
                                        }
                                    }, '基础物质'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 0)
                                            }
                                        }
                                    }, '其它物质')
                                ]
                                return h("div",Buttons)
                            }
                        }
                    },
                    {
                        title: '周二',
                        align: 'center',
                        render:(h,params)=>{
                            if (params.index < 4) {
                                let code = 1 + "" + (params.index+1)
                                let hList = []
                                this.infoItem.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark == null || info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                                return h("div",hList)
                            } else {
                                let Buttons = [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 1, 'basic')
                                            }
                                        }
                                    }, '基础物质'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 1)
                                            }
                                        }
                                    }, '其它物质')
                                ]
                                return h("div",Buttons)
                            }
                        }
                    },
                    {
                        title: '周三',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            if (params.index < 4) {
                                let code = 2 + "" + (params.index+1)
                                let hList = []
                                this.infoItem.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark == null || info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                                return h("div",hList)
                            } else {
                                let Buttons = [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 2, 'basic')
                                            }
                                        }
                                    }, '基础物质'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 2)
                                            }
                                        }
                                    }, '其它物质')
                                ]
                                return h("div",Buttons)
                            }
                        }
                    },
                    {
                        title: '周四',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            if (params.index < 4) {
                                let code = 3 + "" + (params.index+1)
                                let hList = []
                                this.infoItem.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark == null || info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                                return h("div",hList)
                            } else {
                                let Buttons = [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 3, 'basic')
                                            }
                                        }
                                    }, '基础物质'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 3)
                                            }
                                        }
                                    }, '其它物质')
                                ]
                                return h("div",Buttons)
                            }
                        }
                    },
                    {
                        title: '周五',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            if (params.index < 4) {
                                let code = 4 + "" + (params.index+1)
                                let hList = []
                                this.infoItem.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark == null || info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                                return h("div",hList)
                            } else {
                                let Buttons = [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 4, 'basic')
                                            }
                                        }
                                    }, '基础物质'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 4)
                                            }
                                        }
                                    }, '其它物质')
                                ]
                                return h("div",Buttons)
                            }
                        }
                    },
                    {
                        title: '周六',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            if (params.index < 4) {
                                let code = 5 + "" + (params.index+1)
                                let hList = []
                                this.infoItem.infoVOList.forEach(function (infoVO) {
                                    if (infoVO.type == code) {
                                        infoVO.infoList.forEach(function (info) {
                                            if (info.remark == null || info.remark.length <= 0) {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                            } else {
                                                hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                            }
                                        })
                                        return
                                    }
                                })
                                return h("div",hList)
                            } else {
                                let Buttons = [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 5, 'basic')
                                            }
                                        }
                                    }, '基础物质'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.detailGetNutritions(this.infoItem.infoVOList, 5)
                                            }
                                        }
                                    }, '其它物质')
                                ]
                                return h("div",Buttons)
                            }
                        }
                    },
                ],
                key:0,
                updateInfoItem:{id:'',name:'',infoList: []},
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                dietGuidelinesAllList: [],
                dietPlanTemplate: null,
                basicNutritionItems: ['能量', '碳水化合物', '蛋白质', '脂肪'],
                clickItemKey: null
            }
        },
        created(){
            this.pageFindItem()
            this.findAllFoodMaterial()
            this.findAllDietGuidelinesList()
        },
        methods:{
            // 显示当天的营养物质含量
            detailGetNutritions (data, code, type) {
                this.tableLoading = false
                console.log('data', data)
                console.log('code', code)
                let foods= []
                let foodId = []
                data.forEach(function (infoVO) {
                    if (infoVO.type[0] == code) {
                        infoVO.infoList.forEach(function (info) {
                            let temp = {
                                id: info.foodMaterial.id,
                                quantity: info.value
                            }
                            let index = foodId.indexOf(info.foodMaterial.id)
                            if (index > -1) {
                                foods[index].quantity = foods[index].quantity + info.value
                            } else {
                                foods.push(temp)
                                foodId.push(info.foodMaterial.id)
                            }
                        })
                    }
                })
                console.log(foods)
                // 调接口查询食材的营养物质含量，只/不显示热量/碳水化合物/蛋白质/脂肪
                this.basicNutritions (foods, type)
            },
            // 显示当天的基础营养物质含量
            basicNutritions (foods, type) {
                if (foods == null || foods.length <= 0) {
                    this.$Notice.error({title:'未选择食材，请先选择'});
                    return
                }
                let data = []
                this.$http.post('nutrition/calculate/nutrition',foods, {emulateJSON: false}).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        data = msg.data
                        console.log('data', data)
                        this.nutritionItems = []
                        data.forEach(item => {
                            if (type === 'basic') {
                                if (this.basicNutritionItems.indexOf(item.name) > -1) {
                                    this.nutritionItems.push(item)
                                }
                            } else {
                                if (this.basicNutritionItems.indexOf(item.name) < 0) {
                                    this.nutritionItems.push(item)
                                }
                            }

                        })
                        console.log('nutritionItems', this.nutritionItems)
                        this.nutritionModal = true
                    }else {
                        this.$Notice.error({title:'营养物质获取失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            // 修改或新增时显示当天的营养物质含量
            editGetNutritions (data, code, type) {
                this.tableLoading = false
                console.log('data', data)
                console.log('code', code)
                let foods= []
                let foodId = []
                for (let key of Object.keys(data)) {
                  if (key[0] == code) {
                    let info = data[key]
                    let temp = {
                      id: info.foodMaterialId,
                      quantity: info.value
                    }
                    let index = foodId.indexOf(info.foodMaterialId)
                    if (index > -1) {
                      foods[index].quantity = foods[index].quantity + info.value
                    } else if (info.foodMaterialId !== ''){
                      foods.push(temp)
                      foodId.push(info.foodMaterialId)
                    }
                  }
                }
                console.log(foods)
                // 调接口查询食材的营养物质含量，只/不显示热量/碳水化合物/蛋白质/脂肪
                this.basicNutritions (foods, type)
            },
            // 获取饮食原则
            findAllDietGuidelinesList() {
                this.$http.post('dietGuidelines/list', {
                    isDeleted: false,
                    pageSize: 0,
                    pageNum: 0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.dietGuidelinesAllList = msg.data
                    } else {
                        this.$Notice.error({title: '饮食原则查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllFoodMaterial(){
                this.$http.post('foodMaterial/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.foodMaterialAllList = []
                        for (let i in msg.data.list) {
                            if (msg.data.list[i].nutritionTypeList.length > 0) {
                                this.foodMaterialAllList.push(msg.data.list[i])
                            } else {
                            }
                        }
                    }else {
                        this.$Notice.error({title:'食材查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('dietPlan/listTemplate',{
                    name:this.select.name,
                    sex: this.select.sex ? this.select.sex : null,
                    age: this.select.age ? this.select.age : null,
                    isDeleted:this.select.isDeleted ? this.select.isDeleted : null,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'食谱模板列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addTemplateInfo(week){
                if (!this.addItem.infoList[week]) {
                    this.$set(this.addItem.infoList, week,  [])
                }
                let temp = this.addItem.infoList[week]
                temp.push({
                    foodMaterialId:'',
                    value:0,
                    type:week,
//                    remark:'',
                    unit:'',
                    select: {edit: true, click: true},
                    key: new Date().getTime()
                })
//                this.addItem.infoList[week].push({
//                    foodMaterialId:'',
//                    value:0,
//                    type:week,
//                    remark:'',
//                    unit:'',
//                    select: {edit: true, click: true},
//                    key: new Date().getTime()
//                })
                this.$set(this.addItem.infoList, week, temp)
                console.log('11111', this.addItem.infoList)
                this.$forceUpdate()
//                if (!this.addItem.infoList[week]) {
//                  this.addItem.infoList[week] = []
//                }
//                this.addItem.infoList[week].push({
//                  foodMaterialId:'',
//                  type:week,
//                  value:0,
//                  unit:'',
//                  remark:'',
//                  select: {edit: true, click: true},
//                  key:this.key++
//                })
            },
            removeTemplateInfo(index, week){
                this.addItem.infoList[week].splice(index, 1)
            },
            changeSelect(value,templateInfo){
              if (templateInfo.foodMaterial != null && templateInfo.foodMaterial.name != null) {
                templateInfo.foodMaterial.name = value.label
              }
              templateInfo['foodMaterialName'] = value.label
              templateInfo.select.edit = templateInfo.select.click = false
            },
            addItem_modal(){
                let InfoList = {}
                for (let i = 0 ; i < 7 ; i++ ) {
                    for (let j = 1 ; j < 5 ; j++ ){
                        InfoList[''+i+j] = []
                    }
                }
                this.addItem.infoList = InfoList
                this.addModel = true
            },
            addItemClick(){
                if (this.addItem.name.length <= 0){
                    return this.$Message.warning('请输入食谱模板名称');
                }
                let flag = false
                let infoList = []
                for (let key of Object.keys(this.addItem.infoList)) {
                  infoList = infoList.concat(this.addItem.infoList[key])
                }
                infoList.forEach(function (TemplateInfo) {
                    if (TemplateInfo.foodMaterialId.length <= 0 && TemplateInfo.value != null && TemplateInfo.value <= 0){
                        flag = true
                        return
                    }
                })
                if (flag || infoList.length <= 0) {
                    return this.$Message.warning('请填写完整数据');
                }
                this.addLoading = true
                this.$http.post('dietPlan/addTemplate',{
                    name:this.addItem.name,
                    sex: this.addItem.sex,
                    ageMin: this.addItem.ageMin ? this.addItem.ageMin : null,
                    ageMax: this.addItem.ageMax ? this.addItem.ageMax : null,
                    infoList:JSON.stringify(infoList)
                }).then(function (res) {
                    let msg = res.body
                    this.dietPlanTemplate = msg.data
                    if (msg.success) {
                        this.bindTemplateDietGuidelines(this.dietPlanTemplate, this.addItem.dietGuidelines)
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食谱模板新增失败',desc: msg.message});
                    }
                    this.cancelItem()
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            bindTemplateDietGuidelines(value, dietGuideLine){
                if (!dietGuideLine) return
                this.$http.post('dietPlan/bindTemplateDietGuideline',{
                    id: value.id,
                    guidelinesIds:JSON.stringify(dietGuideLine)
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'失败',desc: msg.message});
                    }
                    this.cancelItem()
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            addInfoList(week){
                if (!this.updateInfoItem.infoList[week]) {
                  this.$set(this.updateInfoItem.infoList, week,  [])
                }
                this.updateInfoItem.infoList[week].push({
                  dietPlanTemplateId:this.updateInfoItem.id,
                  foodMaterialId:'',
                  value:0,
                  type:week,
                  remark:'',
                  unit:'',
                  select: {edit: true, click: true},
                  key: new Date().getTime()
                })
            },
            removeInfoList(index, week){
                this.updateInfoItem.infoList[week].splice(index, 1)
            },
            updateItem_modal(item){
                this.updateInfoItem = item
                this.updateInfoItem.id = item.id
                this.updateInfoItem.name = item.name;
                let infoList = {}
                item.infoVOList.forEach((i)=>{
                    i.infoList.forEach((info)=> {
                        info['key'] = this.key++
                        info['unit'] = info.foodMaterial.unit
                        info['select'] = {edit: false, click: false}
                        if (!infoList[info.type])  infoList[info.type] = []
                        infoList[info.type].push(JSON.parse(JSON.stringify(info)))
                    })
                })
                this.updateInfoItem.dietGuidelines = []
                item.dietGuidelinesList.forEach(i => {
                    this.updateInfoItem.dietGuidelines.push(i.id)
                })
//                this.updateInfoItem.infoList = infoList
                this.$set(this.updateInfoItem, 'infoList', infoList)
                this.dietGuideLine = this.updateInfoItem.dietGuidelines
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.name.length <= 0){
                    return this.$Message.warning('请输入食谱模板名称');
                }
                let flag = false
                let infoList = []
                for (let key of Object.keys(this.updateInfoItem.infoList)) {
                  infoList = infoList.concat(this.updateInfoItem.infoList[key])
                }
                infoList.forEach((TemplateInfo) => {
                    if (TemplateInfo.foodMaterialId.length <= 0 && TemplateInfo.value != null && TemplateInfo.value <= 0){
                        flag = true
                        return
                    }
                })
                if (flag || infoList.length <= 0) {
                    return this.$Message.warning('请填写完整数据');
                }
                this.updateLoading = true
                this.$http.post('dietPlan/updateTemplate',{
                    id:this.updateInfoItem.id,
                    name:this.updateInfoItem.name,
                    ageMin: this.updateInfoItem.ageMin ? this.updateInfoItem.ageMin : null,
                    ageMax: this.updateInfoItem.ageMax ? this.updateInfoItem.ageMax : null,
                    sex: this.updateInfoItem.sex,
                    infoList:JSON.stringify(infoList)
                }).then(function (res) {
                    let msg = res.body
                    this.dietPlanTemplate = msg.data
                    if (msg.success) {
                        this.bindTemplateDietGuidelines(this.dietPlanTemplate, this.updateInfoItem.dietGuidelines)
//                        this.$Notice.success({title: '食谱模板修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食谱模板修改失败',desc: msg.message});
                    }
                    this.cancelItem()
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.name = ''
                this.key = 0
                this.TemplateInfoList.length = 0
                this.dietGuideLine = null
                this.addItem = {
                    name:'',
                    sex: null,
                    ageMin: null,
                    ageMax: null,
                    infoList: []
                }
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoItem.dietGuidelines = []
                item.dietGuidelinesList.map(item => {
                    this.infoItem.dietGuidelines.push(item.id)
                })
                this.infoModel = true
            },
            CopyItem_modal(item){
                this.addItem = item
                this.addItem['id'] = null
                this.addItem.name = item.name;
                let infoList = {}
                item.infoVOList.forEach((i)=>{
                    i.infoList.forEach((info)=> {
                        info['key'] = this.key++
                        info['unit'] = info.foodMaterial.unit
                        info['select'] = {edit: false, click: false}
                        if (!infoList[info.type])  infoList[info.type] = []
                        infoList[info.type].push(JSON.parse(JSON.stringify(info)))
                    })
                })
                this.addItem.dietGuidelines = []
                item.dietGuidelinesList.forEach(i => {
                    this.addItem.dietGuidelines.push(i.id)
                })
//                this.addItem.infoList = infoList
                this.$set(this.addItem, 'infoList', infoList)
                this.dietGuideLine = this.addItem.dietGuidelines
                console.log(' this.addItem', item, this.addItem)
                this.addModel = true
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用食谱模板“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('dietPlan/reuseTemplate',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食谱模板启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食谱模板启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用食谱模板“'+ item.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('dietPlan/deleteTemplate',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食谱模板禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食谱模板禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style scoped type="scss">
    .home-container{

    }

    .my_Button:focus{
        box-shadow: 0 0 0 0;
    }
</style>
